import React from 'react';
import EllipsedWithTooltip from '@atlassian/jira-portfolio-3-portfolio/src/common/view/ellipsed-with-tooltip/index.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types.tsx';

export default function GroupContainer({
	height,
	width,
	position,
	title,
	tooltipKey,
	iconBefore,
	testId,
	children,
	toolTipContent,
}: Props) {
	return (
		<>
			<div
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.container}
				style={{
					top: position.y - height / 2,

					left: position.x - width / 2,
					width,
					height,
				}}
			/>
			<div
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styles.name}
				style={{
					top: position.y - height / 2,

					left: position.x - width / 2,
					width,
				}}
				data-testid={testId}
			>
				{iconBefore}
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.title}>
					<EllipsedWithTooltip content={toolTipContent || title} id={tooltipKey}>
						{children ?? <span>{title}</span>}
					</EllipsedWithTooltip>
				</div>
			</div>
		</>
	);
}
